import { itemsCol } from '../../shared/array-types';
import { rowScalar } from '../../encounter-map/ft3d/perception';
import { carriedKeys } from '../minigames/use-key';
import { inventoryIdOf, LOCKED_STATUS_ID, type Row, upper } from '../minigames/rows';
import { statusField } from '../../encounter-map/ft3d/perception';
import { geometryStatusBefore } from './relocation-inputs';
export function doorRowItemType(row:Row,actor:Row,encounter:Row):string {
  const direct=itemsCol(row,'item_type');if(direct)return String(direct);
  const id=String(rowScalar(row,'inventory_item_id')??'').toUpperCase();
  for(const root of [row,actor,encounter]){const type=itemsCol((root.catalog as Row|undefined)?.[id],'item_type');if(type)return String(type);}
  return '';
}
export function doorLockPlan(actor: Row, hostId: string, rows: Row[], bindings: {lock_id:string;secured_id:string}[],
  lock: boolean, itemType: (r: Row)=>string, selectedLockId?:string): { lockId:string; keyId:string; additions:Row[]; removals:Row[] } {
  const hosts = new Set([upper(hostId)]);
  const lockIds = new Set(bindings.filter(b=>upper(b.secured_id)===upper(hostId)).map(b=>upper(b.lock_id)));
  const host = rows.find(r=>inventoryIdOf(r)===upper(hostId));
  if (!host) throw new Error('door:host-not-held');
  for (const s of ftCreatureStatuses(host,'target') as Row[]) if (upper(statusField(s,'status_item_id'))===LOCKED_STATUS_ID) lockIds.add(upper(statusField(s,'status_caster_id')));
  if (itemType(host)==='lock') lockIds.add(upper(hostId));
  if(selectedLockId){if(!lockIds.has(upper(selectedLockId)))throw new Error('door:lock-not-bound');lockIds.clear();lockIds.add(upper(selectedLockId));}
  const keys=carriedKeys(actor,{itemType,uuid:()=>''});
  const key=keys.find(k=>k.opens.some(id=>lockIds.has(id)||hosts.has(id)));
  if (!key) throw new Error(keys.length?'door:no-matching-key':'door:no-keys');
  const lockId=[...lockIds].find(id=>key.opens.includes(id)) ?? [...lockIds][0];
  if (!lockId) throw new Error('door:lock-not-held');
  const hardware=rows.find(r=>inventoryIdOf(r)===lockId);
  if (!hardware) throw new Error('door:lock-not-held');
  const active=(ftCreatureStatuses(hardware,'caster') as Row[]).filter(s=>upper(statusField(s,'status_item_id'))===LOCKED_STATUS_ID);
  if (lock && active.length) throw new Error('door:already-locked');
  if (!lock && !active.length) throw new Error('door:not-locked');
  const targets=new Set([lockId,upper(hostId),...bindings.filter(b=>upper(b.lock_id)===lockId).map(b=>upper(b.secured_id))]);
  return {lockId,keyId:key.id,removals:lock?[]:active.map(s=>({status_id:upper(statusField(s,'status_id')),before:geometryStatusBefore(s)})),
    additions:lock?[...targets].map(id=>({status_id:crypto.randomUUID().toUpperCase(),status_item_id:LOCKED_STATUS_ID,status_caster_id:lockId,status_target_id:id,status_connected_id:lockId})):[]};
}
